import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { mapState } from "vuex";
import _ from "lodash";
import Pheard from "./Layout/Head";
import { getMenuLabel, menuListJs } from "@/libs/menu-list";
import findActiveName from "../libs/findActiveName";
import ValidPassword from "@/components/Modal/ValidPassword.vue";
export default {
  name: "Main",
  data() {
    return {
      menuList: [],
      collapsedWidth: 208,
      openNames: [],
      activeName: "",
      collapsed: false,
      menuCategory: {
        addressBook: () => $t("ls4kg3", "通讯录"),
        safety: () => $t("ddjt1m5", "安全和认证"),
        audit: () => $t("gco02", "审计"),
        systemManagement: () => $t("lydg2", "系统")
      },
      menuIconMap: {
        enterpriseHome: "dashboard",
        addressBook: "contacts",
        safety: "shield",
        audit: "manage_search",
        systemManagement: "settings"
      }
    };
  },
  components: {
    Pheard,
    ValidPassword
  },
  computed: {
    ...mapState({
      appCode: state => state.app.appCode,
      user: state => state.user,
      tabList: state => {
        var _state$tabs;
        return ((_state$tabs = state.tabs) === null || _state$tabs === void 0 ? void 0 : _state$tabs.options) || [];
      },
      isMobile: state => state.app.isMobile
    }),
    activeLink() {
      const {
        fullPath
      } = this.$route;
      return fullPath;
    },
    // 仅工作台移动端保持侧栏覆盖式展开，避免菜单占位后把应用卡片区域挤压变形。
    isWorkbenchMobileMenuOverlay() {
      return this.isMobile && this.$route.name === "MGT";
    }
  },
  watch: {
    "user.userInfo": function (val) {
      this.refreshMenuList(val);
    },
    "user.visibleApps": {
      deep: true,
      handler() {
        this.refreshMenuList(this.user.userInfo);
      }
    },
    isMobile: {
      immediate: true,
      handler(isMobile) {
        if (isMobile) {
          this.collapsed = true;
          this.collapsedWidth = 0;
        } else {
          this.collapsed = false;
          this.collapsedWidth = 208;
        }
      }
    },
    $route: function () {
      this.freshMenus();
    }
  },
  mounted() {
    this.$bus.$on("selectMenu", this.fuck);
    if (this.$refs.sider) {
      const siderEl = this.$refs.sider.$el;
      if (siderEl) {
        siderEl.addEventListener("mouseenter", this.mouseEnter);
      }
    }
    this.$nextTick(() => {
      if (this.$refs.contentMain) {
        const contentMainEl = this.$refs.contentMain.$el;
        if (contentMainEl) {
          contentMainEl.addEventListener("click", this.handleContentClick, true);
        }
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off("selectMenu", this.fuck);
    if (this.$refs.sider) {
      const siderEl = this.$refs.sider.$el;
      if (siderEl) {
        siderEl.removeEventListener("mouseenter", this.mouseEnter);
      }
    }
    if (this.$refs.contentMain) {
      const contentMainEl = this.$refs.contentMain.$el;
      if (contentMainEl) {
        contentMainEl.removeEventListener("click", this.handleContentClick, true);
      }
    }
  },
  methods: {
    // 菜单标签在语言包完成加载后才执行自动翻译函数。
    translateMenuLabel(menu) {
      return getMenuLabel(menu);
    },
    // 分组标题与菜单同样延迟解析，避免切换语言后回退到中文。
    translateMenuCategory(menuName) {
      const category = this.menuCategory[menuName];
      return typeof category === "function" ? category() : category || "";
    },
    mouseEnter() {
      // 移动端菜单改为布局内展开，避免触屏环境下 hover 误触导致侧栏遮挡内容。
      if (this.isMobile) return;
      if (this.collapsed) {
        this.collapsed = false;
        this.collapsedWidth = 208;
      }
    },
    collapsedSider() {
      this.collapsed = !this.collapsed;
      if (this.isMobile) {
        this.collapsedWidth = this.collapsed ? 0 : 208;
      } else {
        this.collapsedWidth = this.collapsed ? 70 : 208;
      }
    },
    fuck() {
      this.activeName = "enterpriseHome";
      this.$nextTick(() => {
        this.$refs.menu.updateActiveName("enterpriseHome");
        this.$refs.menu.updateOpened([]);
      });
    },
    handleContentClick(event) {
      if (this.isMobile && !this.collapsed) {
        this.collapsed = true;
        this.collapsedWidth = 0;
        event.stopPropagation();
      }
    },
    selectMenu(menu) {
      if (this.collapsed) {
        this.collapsed = false;
        this.collapsedWidth = 208;
      }
      if (this.isMobile) {
        this.collapsed = true;
        this.collapsedWidth = 0;
      }
      const isExist = _.find(this.tabList, val => (val === null || val === void 0 ? void 0 : val.link) == (menu === null || menu === void 0 ? void 0 : menu.link));
      !isExist && this.tabList.push(menu);
    },
    // 菜单权限同时依赖用户身份和工作台可见应用列表，任一数据变化都需要重新生成。
    refreshMenuList(userInfo = this.user.userInfo) {
      this.menuList = menuListJs(userInfo, this.user.visibleApps);
      if (!this.tabList) {
        if (this.menuList.length > 0) {
          this.findFirstLink(this.menuList);
        }
      } else {
        this.freshMenus();
      }
    },
    findFirstLink(array) {
      let first = _.first(array);
      if (first && _.has(first, "children")) {
        const children = _.get(first, "children");
        if (!_.isEmpty(children)) {
          this.findFirstLink(children);
        } else {
          this.$router.push(first.link);
          this.freshMenus();
        }
      } else {
        this.$router.push(first.link);
        this.freshMenus();
      }
    },
    getActiveMenu() {
      this.menuList.forEach(item => {
        if (item.link === this.activeLink) {
          this.openNames = item.openNames;
          this.activeName = item.name;
        } else if (item.children && item.children.length > 0) {
          item.children.forEach(child => {
            if (child.link === this.activeLink) {
              this.openNames = child.openNames;
              this.activeName = child.name;
            }
          });
        }
      });
    },
    freshMenus() {
      this.getActiveMenu();
      this.$nextTick(() => {
        this.$refs.menu.updateOpened();
        this.$refs.menu.updateActiveName();
      });
    }
  },
  async created() {
    this.menuList = menuListJs(this.user.userInfo, this.user.visibleApps);
    console.log("menuList-------", this.menuList);
    this.$store.commit("setTagOptions", findActiveName(this.menuList, "link", this.activeLink) || []);
    this.$store.dispatch("getDictList");
    if (!this.tabList) {
      if (this.menuList.length > 0) {
        this.findFirstLink(this.menuList);
      }
    } else {
      this.freshMenus();
    }
  }
};